export { setRoute } from './utils';
export { default as path } from './path';



// WEBPACK FOOTER //
// ../~/@jg/justgiving-app-login/app/router/index.js